import DefaultGameParams from "@/classes/DefaultGameParams";

export default class ExtendedGameParams extends DefaultGameParams {
  constructor(gameid, bankId, token, homeUrl, displayName, idToken, addFriendUrl) {
    super(gameid, bankId, token, homeUrl);
    this.displayName = displayName;
    this.idToken = idToken;
    this.addFriendUrl = addFriendUrl;
  }
}